import { FAQType } from '@/fixtures/faq'
import { Game } from '@/fixtures/games'

export const shortSlugToGameNameKey = (shortSlug: Game['shortSlug']) => `${shortSlug}_game_name`

export const formatFAQCopyKey = (id: number, type: FAQType) => `faq_${type === FAQType.Answer ? `answer_` : ''}${id}`

export const errorKeys = (statusCode: number) => {
  switch (statusCode) {
    case 404:
      return {
        title: '404_sub',
        description: '404_bod',
      }
    default:
      return {
        title: 'failed_tit',
        description: 'failed_bod',
      }
  }
}
